import { inPresenceArea as inAreaInUnits, type PresenceArea } from "daedalus-core";
import { AUTHORING_CELL, FOOT_HALF_WIDTH, FOOT_HEIGHT } from "../movement/step.ts";

export { presenceArea, type PresenceArea } from "daedalus-core";

/**
 * The game's inside test for a presence prop (ADR-058 amendment, P1.3-T4): Daedalus's `inPresenceArea`
 * bound to a character's feet box in sixteenths of a tile (ADR-071 decision 5), the unit the game's feet
 * points are drawn and simulated in.
 */

/**
 * The feet box and the authoring cell in sixteenths, the cell a presence area is painted in.
 */
const FEET = { halfWidth: FOOT_HALF_WIDTH, height: FOOT_HEIGHT, cell: AUTHORING_CELL } as const;

/**
 * Whether any cell of a character's feet box lies in an area.
 *
 * @param area The area.
 * @param x The character's feet x in sixteenths.
 * @param y The character's feet line in sixteenths.
 * @returns True when the character is inside.
 */
export function inPresenceArea(area: PresenceArea, x: number, y: number): boolean {
  return inAreaInUnits(area, x, y, FEET);
}
